// Sección "Beneficios": al elegir una razón cambia la media de la banda de arriba.
// Las cifras ya no viven en un panel que se intercambia, sino dentro de cada
// columna, así que acá solo queda el cambio de panel y el control de los videos.

class BenefitsInteractive {
  constructor(root) {
    this.root = root;
    this.items = [...root.querySelectorAll('[data-benefit-index]')];
    this.mediaPanels = [...root.querySelectorAll('[data-media-index]')];
    this.activeIndex = 0;

    this.pauseHiddenVideos();

    this.items.forEach((item) => {
      item.addEventListener('click', () => {
        this.activate(parseInt(item.dataset.benefitIndex, 10));
      });
    });
  }

  activate(idx) {
    if (idx === this.activeIndex) return;
    this.activeIndex = idx;

    this.items.forEach((item, i) => {
      const on = i === idx;
      item.classList.toggle('is-active', on);
      item.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    this.mediaPanels.forEach((panel, i) => {
      panel.classList.toggle('is-active', i === idx);
    });

    this.playVideo(this.mediaPanels[idx]);
  }

  // Los paneles existen todos a la vez: hay que frenar los videos que no se ven,
  // porque con `autoplay` seguirían decodificando de fondo sin que nadie los mire.
  pauseHiddenVideos() {
    this.mediaPanels.forEach((panel, i) => {
      const video = panel.querySelector('video');
      if (video && i !== this.activeIndex) video.pause();
    });
  }

  playVideo(panel) {
    this.pauseHiddenVideos();
    if (!panel) return;
    const video = panel.querySelector('video');
    if (!video) return;
    video.currentTime = 0;
    const p = video.play();
    if (p && p.catch) p.catch(() => {});
  }
}

function initBenefits() {
  document.querySelectorAll('[data-benefits-int]').forEach((root) => {
    if (!root.__benefitsInit) {
      root.__benefitsInit = new BenefitsInteractive(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBenefits);
} else {
  initBenefits();
}

// Soporte para el editor de temas de Shopify (re-render de secciones)
document.addEventListener('shopify:section:load', initBenefits);

// En celular las razones son un acordeón: la que no está activa esconde su
// descripción. Si en el editor se selecciona un bloque, hay que abrirlo o el
// cliente edita un texto que no ve.
document.addEventListener('shopify:block:select', (event) => {
  const item = event.target.closest?.('[data-benefit-index]');
  if (!item) return;
  const root = item.closest('[data-benefits-int]');
  if (root && root.__benefitsInit) {
    root.__benefitsInit.activate(parseInt(item.dataset.benefitIndex, 10));
  }
});
